import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {capitalize, words} from 'lodash/string';
import './FeaturedComparablePrice.scss';
import FeaturedComparablePrice from './FeaturedComparablePrice.lazy';
import {
  resetComparableProperty as resetSalesItem,
  setDisplayField as setDisplaySalesField,
} from 'actionCreators/comparableSales';
import {
  resetComparableProperty as resetListingsItem,
  setDisplayField as setDisplayListingsField,
} from 'actionCreators/comparableListings';
import {setDisplayField as setDisplayRentalsField} from 'actionCreators/comparableRentals';
import {
  comparableListingUpdateFields,
  comparableTypes,
  getFetchingFromState,
  getIsFieldVisible,
  getPropertyFromState,
  getCompItemTitlePrice,
} from 'lib/PropertyUtils';
import AnalyticsGateway from 'lib/AnalyticsGateway';

const comparableSaleUpdateFields = ['salePrice', 'isAgentsAdvice', 'isPriceWithheld'];

/**
 * Hides the RS/UN labels from the page. In the future, they will want the labels visible for sales prices
 * @param property
 * @returns {*&{isPriceWithheld: boolean, isAgentsAdvice: boolean, salePriceIsEdited: *}}
 */
function processEditableProperty(property) {
  return {
    ...property,
    isAgentsAdvice: false,
    isPriceWithheld: false,
  };
}

const mapStateToProps = (state, ownProps) => {
  const {propertyId, comparableType, descriptiveFieldLabel} = ownProps;
  const isSales = 'sales' === comparableType;
  const updateFields = isSales ? comparableSaleUpdateFields : comparableListingUpdateFields;
  const isLoading = getFetchingFromState({propertyId, comparableType, state, updateFields});
  const priceFieldKeyName = updateFields[0];
  const priceEditedFieldName = `${priceFieldKeyName}IsEdited`;
  let property = getPropertyFromState(propertyId, comparableType, state, true);
  if (isSales) {
    property = processEditableProperty(property);
  } else {
    property = {
      ...property,
      listingPrice: getCompItemTitlePrice(comparableType, property),
      listingDate: property.listingDate || property.saleDate,
    };
  }

  const isPriceEdited = property[priceEditedFieldName];
  const isPriceVisible = getIsFieldVisible(priceFieldKeyName, property.displayFields);
  const capitalDescriptiveFieldLabel =
    descriptiveFieldLabel &&
    words(descriptiveFieldLabel)
      .map((w) => capitalize(w))
      .join(' ')
      .trim();

  return {
    ...ownProps,
    capitalDescriptiveFieldLabel,
    isLoading,
    isPriceEdited,
    isPriceVisible,
    isSales,
    property,
    updateFields,
  };
};

const mapDispatchToProps = (dispatch, {comparableType, propertyId}) => {
  const {descriptiveFieldName, displayAction, fieldName, resetAction} = {
    sales: {
      displayAction: setDisplaySalesField,
      resetAction: resetSalesItem,
      fieldName: 'salePrice',
      descriptiveFieldName: 'salePrice',
    },
    listings: {
      displayAction: setDisplayListingsField,
      resetAction: resetListingsItem,
      fieldName: comparableListingUpdateFields[0],
      descriptiveFieldName: 'listingPrice',
    },
    rentals: {
      displayAction: setDisplayRentalsField,
      resetAction: () => console.error('Resetting rentals not supported'),
      fieldName: comparableListingUpdateFields[0],
      descriptiveFieldName: 'listingPrice',
    },
  }[comparableType];
  return {
    onShowHide: (checked) => {
      dispatch(
        displayAction({
          propertyId,
          fieldName: fieldName,
          descriptiveFieldName: AnalyticsGateway.descriptiveFieldNames[descriptiveFieldName],
          visible: checked,
        })
      );
    },
    onReset: (updateFields) => {
      const payload = {
        propertyId,
        updateFields,
      };
      dispatch(resetAction(payload));
    },
  };
};

const mergeProps = (stateProps, dispatchProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
    onReset: () => {
      dispatchProps.onReset(stateProps.updateFields);
    },
  };
};

const FeaturedComparablePriceContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(FeaturedComparablePrice);

export {FeaturedComparablePriceContainer, FeaturedComparablePrice};

FeaturedComparablePriceContainer.propTypes = {
  propertyId: PropTypes.number.isRequired,
  comparableType: PropTypes.oneOf(comparableTypes).isRequired,
  descriptiveFieldLabel: PropTypes.string,
};
export default FeaturedComparablePriceContainer;
